import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { settingsAtlas, settingsNode } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { ClaimGuard, WorkflowMonitorGuard } from '@lsq-frontend/common-ui';
import { Routes } from '@lsq-frontend/common-ui';
import { BankAccountsComponent } from '../supply-chain/bank-accounts/bank-accounts.component';
import { MobileSettingsMenuComponent } from './mobile-settings-menu/mobile-settings-menu.component';
import { NotificationPreferencesComponent } from './notification-preferences/notification-preferences.component';
import { ProfileComponent } from './profile/profile.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SettingsComponent } from './settings.component';
import { UsersPageComponent } from './users/users-page.component';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';

const settingsRoutes: Routes = [
    {
        path: UiRoutes.Home,
        component: SettingsComponent,
        canActivate: [ClaimGuard],
        data: {
            claims: settingsNode.claims
        },
        children: [
            {
                path: UiRoutes.Home,
                redirectTo: settingsAtlas.SETTINGS_PROFILE.path,
                pathMatch: 'full'
            },
            {
                path: settingsAtlas.SETTINGS_MOBILE_MENU.path,
                component: MobileSettingsMenuComponent,
                data: {
                    title: settingsAtlas.SETTINGS_MOBILE_MENU.title
                }
            },
            {
                path: settingsAtlas.SETTINGS_PROFILE.path,
                component: ProfileComponent,
                canDeactivate: [WorkflowMonitorGuard],
                data: {
                    title: settingsAtlas.SETTINGS_PROFILE.title
                }
            },
            {
                path: settingsAtlas.SETTINGS_NOTIFICATION_PREFERENCES.path,
                component: NotificationPreferencesComponent,
                canActivate: [ClaimGuard],
                canDeactivate: [WorkflowMonitorGuard],
                data: {
                    title: settingsAtlas.SETTINGS_NOTIFICATION_PREFERENCES.title,
                    claims: settingsAtlas.SETTINGS_NOTIFICATION_PREFERENCES.claims
                }
            },
            {
                path: settingsAtlas.SETTINGS_RESET_PASSWORD.path,
                component: ResetPasswordComponent,
                canDeactivate: [WorkflowMonitorGuard],
                data: {
                    title: settingsAtlas.SETTINGS_RESET_PASSWORD.title
                }
            },
            {
                path: settingsAtlas.SETTINGS_MANAGE_USERS.path,
                component: UsersPageComponent,
                canActivate: [ClaimGuard],
                canDeactivate: [WorkflowMonitorGuard],
                data: {
                    title: settingsAtlas.SETTINGS_MANAGE_USERS.title,
                    claims: settingsAtlas.SETTINGS_MANAGE_USERS.claims
                }
            },
            {
                path: settingsAtlas.SETTINGS_SCF_MANAGE_USERS.path,
                component: UsersPageComponent,
                canActivate: [ClaimGuard],
                canDeactivate: [WorkflowMonitorGuard],
                data: {
                    title: settingsAtlas.SETTINGS_SCF_MANAGE_USERS.title,
                    claims: settingsAtlas.SETTINGS_SCF_MANAGE_USERS.claims
                }
            },
            {
                path: settingsAtlas.SETTINGS_SCF_DIRECT_BANK_ACCOUNTS.path,
                component: BankAccountsComponent,
                canActivate: [ClaimGuard],
                canDeactivate: [WorkflowMonitorGuard],
                data: {
                    title: settingsAtlas.SETTINGS_SCF_DIRECT_BANK_ACCOUNTS.title,
                    claims: settingsAtlas.SETTINGS_SCF_DIRECT_BANK_ACCOUNTS.claims
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(settingsRoutes)],
    exports: [RouterModule]
})
export class SettingsRoutingModule {}
